import { useLazyGetExactOnlineAuthorizationUrlQuery } from "src/common/service/fusionHub/integrations/exactOnlineApi";
import { URL_SYSTEM_IDENTIFIER } from "src/features/integrations/sources/exact-online/constants";
import { useOAuthAuthorizationUrl } from "src/features/integrations/sources/oauth/useOAuthAuthorizationUrl";

export const useAuthorizationUrl = (companyDomainId: string) =>
	useOAuthAuthorizationUrl({
		useLazyQuery: useLazyGetExactOnlineAuthorizationUrlQuery,
		externalCallbackPath: "/exact-online-external-callback",
		urlSystemIdentifier: URL_SYSTEM_IDENTIFIER,
		errorMessageKey: "Failed to initialize integration with Exact Online.",
		companyDomainId,
	});
